function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import Button from '../button/Button';
import Label from '../label/Label';
import CharacterCounter from './CharacterCounter';
import * as constants from './constants';
import { getAdditionalProps } from '../utils/propTypes'; // The shortest length currency symbol that qualifies for the
// "long" modifier

var CURRENCY_SYMBOL_LONG_MINLENGTH = 2; // TextInput component can render some components inside the form input, such as icons.

var isIconComponent = function isIconComponent(_ref) {
  var type = _ref.type;
  return _.includes(constants.CHILD_COMPONENT_WHITELIST, type);
};

var TextPrefix = function TextPrefix(_ref2) {
  var text = _ref2.text,
      htmlFor = _ref2.htmlFor;

  if (!text) {
    return null;
  }

  return React.createElement(Label, {
    className: "eds-textinput__text-prefix",
    htmlFor: htmlFor
  }, text);
};

var TextSuffix = function TextSuffix(_ref3) {
  var text = _ref3.text,
      showTextSuffix = _ref3.showTextSuffix;

  if (showTextSuffix && text) {
    return React.createElement("div", {
      className: "eds-textinput__text-suffix"
    }, text);
  }

  return null;
};

var TextInput =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TextInput, _PureComponent);

  function TextInput(props) {
    var _this;

    _classCallCheck(this, TextInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextInput).call(this, props));
    var defaultValue = props.defaultValue,
        maxLength = props.maxLength,
        textSuffix = props.textSuffix,
        shouldFocus = props.shouldFocus;
    var value = props.value || defaultValue;

    if (maxLength !== undefined) {
      value = value.substr(0, maxLength);
    }

    _this.state = {
      value: value,
      showTextSuffix: !!textSuffix && !value,
      shouldFocus: shouldFocus === undefined ? false : shouldFocus
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref4) {
      var value = _ref4.value,
          maxLength = _ref4.maxLength,
          shouldFocus = _ref4.shouldFocus,
          textSuffix = _ref4.textSuffix;
      // allows setting an existing `input` element's value via props from a parent
      var trimmedValue = value;

      if (trimmedValue !== undefined) {
        var newState = {
          showTextSuffix: !!textSuffix && !trimmedValue
        };

        if (maxLength !== undefined) {
          trimmedValue = trimmedValue.substr(0, maxLength);
        }

        if (shouldFocus !== undefined) {
          newState = _objectSpread({
            shouldFocus: shouldFocus
          }, newState);
        }

        this.setState(_objectSpread({
          value: trimmedValue
        }, newState));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var shouldFocus = this.state.shouldFocus;

      if (shouldFocus) {
        this._focus();
      }
    }
  }, {
    key: "_getRef",
    value: function _getRef(ref) {
      this._input = ref;
      return this._input;
    }
  }, {
    key: "_blur",
    value: function _blur() {
      this._input.blur();
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._input.focus();
    }
  }, {
    key: "_showHideSuffix",
    value: function _showHideSuffix(value) {
      if (!this.props.textSuffix) {
        return;
      }

      var showTextSuffix = !value;
      this.setState({
        showTextSuffix: showTextSuffix
      });
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      var value = e.target.value;

      this._showHideSuffix(value);

      this.setState({
        value: value
      });

      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      this.setState({
        shouldFocus: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(this.state.value);
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      this.setState({
        shouldFocus: true
      });

      if (this.props.onFocus) {
        this.props.onFocus(this.state.value);
      }
    }
  }, {
    key: "_getIconWrappers",
    value: function _getIconWrappers(iconComponents, iconSubmits) {
      return iconComponents.map(function (iconComponent, index) {
        var iconWrapperClassName = classNames('eds-textinput__icon-container', {
          'eds-textinput__icon-container--right': index > 0
        });
        var contentComponent = iconComponent;

        if (iconSubmits) {
          contentComponent = React.createElement("span", {
            className: "eds-textinput__icon-container__button"
          }, React.createElement(Button, {
            type: "submit",
            style: "none"
          }, iconComponent));
        } // `iconCompnoents` is an array of React components and nothing
        // prevents the icons from being identical

        /* eslint-disable react/no-array-index-key */


        return React.createElement("div", {
          className: iconWrapperClassName,
          key: index,
          "data-spec": "text-input-icon-wrapper"
        }, contentComponent);
        /* eslint-enable react/no-array-index-key */
      });
    }
  }, {
    key: "_getCurrencySymbolContent",
    value: function _getCurrencySymbolContent(currencySymbol) {
      var content;

      if (currencySymbol) {
        content = React.createElement("div", {
          className: "eds-textinput__curency-symbol"
        }, currencySymbol);
      }

      return content;
    }
  }, {
    key: "_getComponent",
    value: function _getComponent(_ref5) {
      var input = _ref5.input,
          id = _ref5.id,
          disabled = _ref5.disabled,
          shouldFocus = _ref5.shouldFocus,
          hasError = _ref5.hasError,
          value = _ref5.value,
          maxLength = _ref5.maxLength,
          showCounter = _ref5.showCounter,
          iconComponents = _ref5.iconComponents,
          iconAlignRight = _ref5.iconAlignRight,
          iconSubmits = _ref5.iconSubmits,
          hideOutline = _ref5.hideOutline,
          currencySymbol = _ref5.currencySymbol,
          currencySymbolIsSuffix = _ref5.currencySymbolIsSuffix,
          textPrefix = _ref5.textPrefix,
          textSuffix = _ref5.textSuffix,
          showTextSuffix = _ref5.showTextSuffix,
          __containerClassName = _ref5.__containerClassName;
      var numIcons = iconComponents.length;
      var hasIcons = numIcons > 0;
      var component = input;
      var contentWrapperClassName = classNames('eds-textinput', {
        'eds-textinput--error': hasError,
        'eds-textinput--focus': shouldFocus,
        'eds-textinput--disabled': disabled,
        'eds-textinput--has-icon': hasIcons,
        'eds-textinput--has-icon--right': iconAlignRight,
        'eds-textinput--has-icon--double': numIcons > 1,
        'eds-textinput--has-icon--action': hasIcons && iconSubmits,
        'eds-textinput--hide-outline': hideOutline,
        'eds-textinput--currency': currencySymbol,
        'eds-textinput--has-currency-suffix': currencySymbol && currencySymbolIsSuffix,
        'eds-textinput--currency--medium': currencySymbol && currencySymbol.length === CURRENCY_SYMBOL_LONG_MINLENGTH,
        'eds-textinput--currency--long': currencySymbol && currencySymbol.length > CURRENCY_SYMBOL_LONG_MINLENGTH,
        'eds-textinput--has-text-prefix': textPrefix,
        'eds-textinput--has-text-suffix': showTextSuffix
      }, __containerClassName);

      var iconWrappers = this._getIconWrappers(iconComponents, iconSubmits);

      var currencySymbolContent = this._getCurrencySymbolContent(currencySymbol);

      component = React.createElement("div", {
        className: contentWrapperClassName,
        "data-spec": "text-input-wrapper"
      }, React.createElement(CharacterCounter, {
        value: value,
        maxLength: maxLength,
        showCounter: showCounter && shouldFocus
      }), currencySymbolContent, React.createElement(TextPrefix, {
        text: textPrefix,
        htmlFor: id
      }), input, iconWrappers, React.createElement(TextSuffix, {
        text: textSuffix,
        showTextSuffix: showTextSuffix
      }));
      return component;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          id = _this$props.id,
          name = _this$props.name,
          role = _this$props.role,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          required = _this$props.required,
          hasError = _this$props.hasError,
          __containerClassName = _this$props.__containerClassName,
          iconAlignRight = _this$props.iconAlignRight,
          iconSubmits = _this$props.iconSubmits,
          hideOutline = _this$props.hideOutline,
          children = _this$props.children,
          dataSpec = _this$props['data-spec'],
          currencySymbol = _this$props.currencySymbol,
          currencySymbolIsSuffix = _this$props.currencySymbolIsSuffix,
          maxLength = _this$props.maxLength,
          showCounter = _this$props.showCounter,
          textPrefix = _this$props.textPrefix,
          textSuffix = _this$props.textSuffix,
          tabIndex = _this$props.tabIndex,
          onMouseOver = _this$props.onMouseOver;
      var _this$state = this.state,
          shouldFocus = _this$state.shouldFocus,
          value = _this$state.value,
          showTextSuffix = _this$state.showTextSuffix;
      var extraAttrs = getAdditionalProps(this);
      var iconComponents = React.Children.toArray(children).filter(isIconComponent);
      var needsWrapper = iconComponents.length > 0;
      var extraInputClasses = {};

      if (__containerClassName) {
        extraInputClasses[__containerClassName] = !needsWrapper;
      }

      var inputClassName = classNames('eds-textinput__input', extraInputClasses);
      var input = React.createElement("input", _extends({}, extraAttrs, {
        ref: this._getRef.bind(this),
        "data-spec": dataSpec,
        type: type,
        role: role,
        className: inputClassName,
        id: id,
        name: name,
        placeholder: placeholder,
        maxLength: maxLength,
        tabIndex: tabIndex,
        disabled: disabled,
        "aria-required": required,
        "aria-invalid": hasError,
        value: this.state.value,
        onChange: this._handleChange.bind(this),
        onBlur: this._handleBlur.bind(this),
        onFocus: this._handleFocus.bind(this),
        onMouseOver: onMouseOver
      }));
      return this._getComponent({
        input: input,
        id: id,
        hasError: hasError,
        disabled: disabled,
        value: value,
        shouldFocus: shouldFocus,
        maxLength: maxLength,
        showCounter: showCounter,
        iconComponents: iconComponents,
        iconAlignRight: iconAlignRight,
        iconSubmits: iconSubmits,
        hideOutline: hideOutline,
        currencySymbol: currencySymbol,
        currencySymbolIsSuffix: currencySymbolIsSuffix,
        textPrefix: textPrefix,
        textSuffix: textSuffix,
        showTextSuffix: showTextSuffix,
        __containerClassName: __containerClassName
      });
    }
  }]);

  return TextInput;
}(PureComponent);

_defineProperty(TextInput, "propTypes", {
  /**
   * TextInput type: text, password, email, url, tel, search,
   * date, number
   */
  type: PropTypes.oneOf(constants.TYPES),

  /**
   * Role of text input
   */
  role: PropTypes.string,

  /**
   * Default value of text input
   * This is the initial value
   * After the text input has been rendered the first time,
   * if the default value changes, it will *not* update the input
   */
  defaultValue: PropTypes.string,

  /**
   * Value of text input
   * The value can override the default value if specified
   * After the text input has been rendered the first time,
   * if the value changes, it *will* update the input
   */
  value: PropTypes.string,

  /**
   * ID of element
   */
  id: PropTypes.string,

  /**
   * Name of element
   */
  name: PropTypes.string,

  /**
   * Default placeholder for input field
   */
  placeholder: EBPropTypes.translation,

  /**
   * Character limit
   */
  maxLength: PropTypes.number,

  /**
   * Show character limit counter
   */
  showCounter: PropTypes.bool,

  /**
   * Is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Is required
   */
  required: PropTypes.bool,

  /**
   * Set error state
   */
  hasError: PropTypes.bool,

  /**
   * Container class name
   */
  __containerClassName: PropTypes.string,

  /**
   * {function} onChange
   */
  onChange: PropTypes.func,

  /**
   * {function} onBlur
   */
  onBlur: PropTypes.func,

  /**
   * {function} onFocus
   */
  onFocus: PropTypes.func,

  /**
   * {function} onMouseOver
   */
  onMouseOver: PropTypes.func,

  /**
   * Identifier for tests
   */
  'data-spec': PropTypes.string,

  /**
   * TextInput supports 1 or 2 icon children,
   * which turns the component into a Text Input w/ icons
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),

  /**
   * Whether or not the specified icon (in children) should be right-aligned
   */
  iconAlignRight: PropTypes.bool,

  /**
   * Whether or not the specified icon (in children) should be wrapped in
   * a submit button
   */
  iconSubmits: PropTypes.bool,

  /**
   * The currency symbol to be included within the text input
   */
  hideOutline: PropTypes.bool,

  /**
   * Hide the visibility of the outline around the text input
   */
  currencySymbol: EBPropTypes.translation,

  /**
   * Whether or not the specified currency symbol should be placed at the end
   */
  currencySymbolIsSuffix: PropTypes.bool,

  /**
   * Text prefix
   */
  textPrefix: EBPropTypes.translation,

  /**
   * Text suffix
   */
  textSuffix: EBPropTypes.translation,

  /**
   * Whether or not we should focus the input field
   */
  shouldFocus: PropTypes.bool,

  /**
   * tab-index
   */
  tabIndex: PropTypes.number
});

_defineProperty(TextInput, "defaultProps", {
  type: 'text',
  role: 'textbox',
  defaultValue: '',
  'data-spec': 'text-input',
  showCounter: false,
  hideOutline: false
});

export { TextInput as default };